import { type SxProps, type Theme } from '@mui/material/styles';

export default function mergeSxProps(
  sx1?: SxProps<Theme>,
  sx2?: SxProps<Theme>,
  sx3?: SxProps<Theme>,
  sx4?: SxProps<Theme>,
  sx5?: SxProps<Theme>,
): SxProps<Theme> {
  return [
    ...(Array.isArray(sx1) ? sx1 : sx1 ? [sx1] : []),
    ...(Array.isArray(sx2) ? sx2 : sx2 ? [sx2] : []),
    ...(Array.isArray(sx3) ? sx3 : sx3 ? [sx3] : []),
    ...(Array.isArray(sx4) ? sx4 : sx4 ? [sx4] : []),
    ...(Array.isArray(sx5) ? sx5 : sx5 ? [sx5] : []),
  ];
}
